export const manifest = {
  screens: {
    scr_eie94f: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_jjw4rh: { name: "The Foundation", route: "/#foundation", position: {"x":1560,"y":220} },
    scr_t33srn: { name: "Communities", route: "/#communities", position: {"x":2960,"y":220} },
    scr_2bijqk: { name: "Meet ATNA", route: "/#atna", position: {"x":4360,"y":220} },
    scr_en2fzt: { name: "Proof at Scale", route: "/#proof", position: {"x":5760,"y":220} },
    scr_9t13lr: { name: "Demo — Request", route: "/request-demo", state: {"step":0}, position: {"x":160,"y":2200} },
    scr_k7zs13: { name: "Demo — Booked", route: "/request-demo", state: {"step":1}, position: {"x":1560,"y":2200} },
    scr_b0bqzm: { name: "City of Brossard", route: "/brossard", position: {"x":160,"y":4180} },
    scr_khdl55: { name: "Core Infrastructure", route: "/core-infrastructure", position: {"x":1560,"y":4180} },
    scr_ds3mdr: { name: "Digital Card", route: "/digital-card", position: {"x":2960,"y":4180} },
    scr_slhvgk: { name: "Requests", route: "/requests", position: {"x":160,"y":6160} },
    scr_0l2jyo: { name: "Smart Water", route: "/smart-water", position: {"x":4360,"y":4180} },
    scr_r00wxk: { name: "Casselman", route: "/casselman", position: {"x":5760,"y":4180} },
    scr_xzznm1: { name: "Communications", route: "/communications", position: {"x":1560,"y":6160} },
    scr_3519j3: { name: "Collect", route: "/collect", position: {"x":2960,"y":6160} },
    scr_gh58pz: { name: "Analytics", route: "/analytics", position: {"x":160,"y":8140} },
    scr_h9l0yg: { name: "ATNA Assistant", route: "/atna", position: {"x":160,"y":10120} },
    scr_obsxho: { name: "BCITI Platform", route: "/platform", position: {"x":160,"y":12100} },
    scr_db5qjd: { name: "Cities & Government", route: "/cities-government", position: {"x":160,"y":14080} },
    scr_29usra: { name: "Airports & Transportation", route: "/industries/airports", position: {"x":160,"y":16060} },
    scr_m0zcab: { name: "Telecommunications & Media", route: "/industries/telecom", position: {"x":1560,"y":16060} },
    scr_3lpf6a: { name: "Health", route: "/industries/health", position: {"x":2960,"y":16060} },
    scr_kp6snt: { name: "Universities & Campuses", route: "/industries/universities", position: {"x":4360,"y":16060} },
    scr_eifu5k: { name: "Trust", route: "/trust", position: {"x":160,"y":18040} },
    scr_cek0d7: { name: "About", route: "/about", position: {"x":7160,"y":220} },
    scr_d3xt8d: { name: "Permis ATNA", route: "/permis", position: {"x":8560,"y":220} },
    scr_yafn4c: { name: "Médailles Animaux", route: "/licences-animaux", position: {"x":7160,"y":4180} },
    scr_ow2a5u: { name: "Expérience numérique", route: "/portail", position: {"x":8560,"y":4180} },
    scr_128ycf: { name: "Secteurs", route: "/secteurs", position: {"x":5760,"y":16060} },
    scr_c8uyqj: { name: "Formation Communications ATNA", route: "/formation-communications", position: {"x":9960,"y":4180} },
  },
  sections: {
    sec_drlswp: { name: "Homepage Navigation", x: 0, y: 0, width: 9920, height: 1180 },
    sec_tpoyww: { name: "Request Demo Flow", x: 0, y: 1980, width: 7120, height: 1180 },
    sec_wg1zsh: { name: "Case Studies & Resources", x: 0, y: 3960, width: 11320, height: 1180 },
    sec_noywly: { name: "User Services", x: 0, y: 5940, width: 4320, height: 1180 },
    sec_x4gvml: { name: "Analytics Dashboard", x: 0, y: 7920, width: 1520, height: 1180 },
    sec_5nl10h: { name: "ATNA Assistant", x: 0, y: 9900, width: 1520, height: 1180 },
    sec_9xk6e4: { name: "BCITI Platform", x: 0, y: 11880, width: 1520, height: 1180 },
    sec_rnioxs: { name: "Cities & Government", x: 0, y: 13860, width: 1520, height: 1180 },
    sec_z2etju: { name: "Industries & Verticals", x: 0, y: 15840, width: 7120, height: 1180 },
    sec_36so74: { name: "Trust & Credibility", x: 0, y: 17820, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_drlswp", children: [
      { kind: "screen", id: "scr_eie94f" },
      { kind: "screen", id: "scr_jjw4rh" },
      { kind: "screen", id: "scr_t33srn" },
      { kind: "screen", id: "scr_2bijqk" },
      { kind: "screen", id: "scr_en2fzt" },
      { kind: "screen", id: "scr_cek0d7" },
      { kind: "screen", id: "scr_d3xt8d" },
    ] },
    { kind: "section", id: "sec_tpoyww", children: [
      { kind: "screen", id: "scr_9t13lr" },
      { kind: "screen", id: "scr_k7zs13" },
    ] },
    { kind: "section", id: "sec_wg1zsh", children: [
      { kind: "screen", id: "scr_b0bqzm" },
      { kind: "screen", id: "scr_khdl55" },
      { kind: "screen", id: "scr_ds3mdr" },
      { kind: "screen", id: "scr_0l2jyo" },
      { kind: "screen", id: "scr_r00wxk" },
      { kind: "screen", id: "scr_yafn4c" },
      { kind: "screen", id: "scr_ow2a5u" },
      { kind: "screen", id: "scr_c8uyqj" },
    ] },
    { kind: "section", id: "sec_noywly", children: [
      { kind: "screen", id: "scr_slhvgk" },
      { kind: "screen", id: "scr_xzznm1" },
      { kind: "screen", id: "scr_3519j3" },
    ] },
    { kind: "section", id: "sec_x4gvml", children: [
      { kind: "screen", id: "scr_gh58pz" },
    ] },
    { kind: "section", id: "sec_5nl10h", children: [
      { kind: "screen", id: "scr_h9l0yg" },
    ] },
    { kind: "section", id: "sec_9xk6e4", children: [
      { kind: "screen", id: "scr_obsxho" },
    ] },
    { kind: "section", id: "sec_rnioxs", children: [
      { kind: "screen", id: "scr_db5qjd" },
    ] },
    { kind: "section", id: "sec_z2etju", children: [
      { kind: "screen", id: "scr_29usra" },
      { kind: "screen", id: "scr_m0zcab" },
      { kind: "screen", id: "scr_3lpf6a" },
      { kind: "screen", id: "scr_kp6snt" },
      { kind: "screen", id: "scr_128ycf" },
    ] },
    { kind: "section", id: "sec_36so74", children: [
      { kind: "screen", id: "scr_eifu5k" },
    ] },
  ],
}
